import AddIcon from '@mui/icons-material/Add';
import { useTheme, Button } from '@mui/material';
import type { FC, MouseEvent as ReactMouseEvent, PropsWithChildren } from 'react';
import { useMedia } from 'react-use';

import { composites } from '../../../../../common/constants/access';
import { sideMenuStrings } from '../../../../constants/strings';
import { UI_BUTTON_PRIMARY } from '../../../../constants/uiConstants';
import { useCreateRequest } from '../../../../hooks/useCreateRequest';
import { StyledMenuItem } from '../../../../material-ui-theme/components/styled/StyledMenuItem';
import { useGetVerifyUserAccess } from '../../../../queries/userQuery';
import { useZustand } from '../../../../zustandStore';

const CreateNewRequestButton: FC<PropsWithChildren> = () => {
	const isOpenOnDesktopView = useZustand(state => state.sideMenu.isOpenOnDesktopView ?? true);
	const isOpenOnMobileView = useZustand(state => state.sideMenu.isOpenOnMobileView ?? false);
	const { openSideMenuOnMobileView } = useZustand();
	const theme = useTheme();
	const {
		data: isCompanySettingsVisible,
		isLoading: isLoadingIsCompanySettingsVisible,
		isError: isVerifyAccessError,
	} = useGetVerifyUserAccess((composites as any).WRITE_COMPANY);
	const isMobileWidth = useMedia('(max-width: 650px)');
	const { createRequest: createNewRequest } = useCreateRequest();

	const createRequest = (e: ReactMouseEvent<HTMLButtonElement>) => {
		if (isMobileWidth) {
			openSideMenuOnMobileView(false);
		}
		void createNewRequest(e);
	};

	if (isVerifyAccessError) {
		return null;
	}

	return !isCompanySettingsVisible && !isLoadingIsCompanySettingsVisible ? (
		<StyledMenuItem
			style={{
				marginTop: theme.tsGoUnit.tsUnit,
				justifyContent: `${isMobileWidth ? 'flex-start' : 'center'}`,
			}}
		>
			<Button
				data-testid="sideMenu-createRequest-btn"
				id="sideMenu-createRequest-btn"
				color={UI_BUTTON_PRIMARY}
				type="submit"
				variant="contained"
				onClick={createRequest}
				style={{
					fontSize: theme.typography.tsFontSize.default,
					width: isOpenOnMobileView && isMobileWidth ? '100%' : 'initial',
					padding: isOpenOnDesktopView || (isOpenOnMobileView && isMobileWidth) ? '8px 85px' : '8px',
					minWidth: isOpenOnDesktopView || (isOpenOnMobileView && isMobileWidth) ? 'initial' : 'auto',
				}}
			>
				{isOpenOnDesktopView || (isOpenOnMobileView && isMobileWidth) ? (
					sideMenuStrings.SIDE_MENU_CREATE_NEW_REQUEST_BUTTON
				) : (
					<AddIcon />
				)}
			</Button>
		</StyledMenuItem>
	) : null;
};

export default CreateNewRequestButton;
